import { BaseThemeType, styled, Typography } from 'opensolar-ui'
import React from 'react'

type PropTypes = {
  integration: string
}

const Wrapper = styled('div')(({ theme }: { theme: BaseThemeType }) => ({
  padding: '24px',
  backgroundColor: theme.palette.grey[100],
  broderRadius: '10px',
  margin: '32px 0px',
}))

const CreditAppicationDisclaimer: React.FC<PropTypes> = (props) => {
  if (props.integration !== 'propensio') return null
  return (
    <Wrapper>
      <Typography textVariant="body2">
        Propensio Finance Limited is authorised and regulated by the Financial Conduct Authority under registration
        number 806409. Finance is subject to status and only available to UK residents aged 21 and over.
      </Typography>
      <Typography textVariant="body2">
        Propensio Finance has a commercial relationship with OpenSolar who are introducing you to us as a lender. As
        such, a commission will be paid to them by us, should you choose to proceed with the loan. The payment of
        commission by us, to them, will not affect the amount you pay under this agreement.
      </Typography>
    </Wrapper>
  )
}

export default CreditAppicationDisclaimer
